// Projection toggle install module. Drives the `#camera-projection-toggle`
// button near the bottom-left gnomon: flips `params.cameraProjection` between
// 'perspective' and 'orthographic' via the CAMERA_SET_PROJECTION intent (which
// performs the actual camera swap). Lives outside the gnomon module so it
// survives the gnomon's dispose/reinstall during a swap.

import { store, params } from '@store/instance';
import { INTENTS } from '@store/intents';

export function installCameraProjectionToggle(): () => void {
    const btn = document.getElementById('camera-projection-toggle') as HTMLButtonElement | null;
    if (!btn) return () => { /* markup missing */ };
    const icon = btn.querySelector('i');

    const refresh = (): void => {
        const ortho = params.cameraProjection === 'orthographic';
        btn.setAttribute('aria-pressed', ortho ? 'true' : 'false');
        btn.setAttribute('data-mode', params.cameraProjection);
        btn.title = ortho ? 'Orthographic — click for perspective' : 'Perspective — click for orthographic';
        if (icon) icon.className = ortho ? 'fas fa-vector-square' : 'fas fa-cube';
    };

    const onClick = (e: MouseEvent): void => {
        e.preventDefault(); e.stopPropagation();
        const next = params.cameraProjection === 'orthographic' ? 'perspective' : 'orthographic';
        store.dispatch(INTENTS.CAMERA_SET_PROJECTION, { mode: next });
    };
    btn.addEventListener('click', onClick);
    const offMode = store.subscribe('params.cameraProjection', () => refresh());

    refresh();

    return () => {
        btn.removeEventListener('click', onClick);
        offMode();
    };
}
